import {
  Alert,
  AlertTitle,
  Box,
  Button,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { IGroupMessageView } from "../../App/Typings/MessageText";

export function ActionConfirmationDialog({
  handleClose = () => {
    return;
  },
  open,
  message,
}: {
  handleClose: (msg: IGroupMessageView, response: boolean) => void;
  open: boolean;
  message: IGroupMessageView;
}) {
  return (
    <Dialog open={open}>
      <DialogTitle>Confirm Cancel / Delete Message</DialogTitle>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          "& > *": {
            m: 1,
          },
        }}
      >
        <DialogContent>
          <Alert severity="warning">
            <AlertTitle>Scheduled Message:</AlertTitle>
            {message.messageDisplay} — <strong> will be deleted!</strong>
          </Alert>
        </DialogContent>

        <ButtonGroup variant="outlined" aria-label="outlined button group">
          <Button onClick={(e) => handleClose(message, true)}>Yes</Button>
          <Button onClick={(e) => handleClose(message, false)}>No</Button>
        </ButtonGroup>
      </Box>
    </Dialog>
  );
}
